export default __webpack_public_path__ + "static/blog4-8dbbb024b3be609d6b6c48f77ae4f095.jpg";